// frontend/src/components/UI/LoadingScreen.jsx
import React from 'react';

export const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-black/25 backdrop-blur-[2px] flex items-center justify-center z-50">
      <div className="rounded-lg p-8 space-y-4 flex flex-col items-center">
        {/* Primary large loader */}
        <div className="relative">
          {/* Outer spinning ring */}
          <div className="w-16 h-16 border-4 border-white rounded-full animate-spin border-t-transparent shadow-lg" />
          {/* Inner pulsing circle */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 bg-white/30 rounded-full animate-pulse" />
          </div>
        </div>
        
        {/* Loading text with shimmer effect */}
        <div className="relative">
          <span className="text-lg font-medium text-white drop-shadow-lg">
            Loading
            <span className="animate-pulse">...</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;